// Import necessary dependencies and components
import React, { useMemo, useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import {
  Row,
  Col,
  Badge,
  Nav,
  Form,
} from "react-bootstrap";
import ClickBack from "../../../components/buttons/ClickBack";
import { fetchAllFournisseur, ArchiveFournisseur } from "./DataService";
import IconTrash from "../../../images/trash.png";
import IconShow from "../../../images/fi_eye.png";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import OkModal from "../../../components/modal/OkModal";
import SearchBar from "../../../components/SearchBar";
import DynamicTable from "../../../components/DynamicTable";
import ElementsPerPageDropdown from "../Component/ElementsPerPageDropdown";
// Define the functional component
function ListFournisseurs(props) {
  // State to hold user data
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showOkModal, setShowOkModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [nbr, setNbr] = useState(1);
  const [actionType, setActionType] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [nbElement, setNbElement] = useState(10);

  // Nouveaux filtres
  const [statusFilter, setStatusFilter] = useState("all"); // all, active, inactive
  const [villeFilter, setVilleFilter] = useState("");
  const [activiteFilter, setActiviteFilter] = useState("all"); // all, 7days, 30days, 90days, never
  const [sortBy, setSortBy] = useState("date_desc"); // date_desc, date_asc, alpha_asc, alpha_desc, orders_asc, orders_desc

  // Cette fonction pour afficher liste des fournisseurs
  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await fetchAllFournisseur(nbr, nbElement, searchTerm, statusFilter, villeFilter, activiteFilter, sortBy);
      setUserData(data.data);
    } catch (error) {
      console.error("Error lors de affiche liste fournisseur:", error);
    } finally {
      setLoading(false);
    }
  };

  //Cette fonction est pour archiver un fournisseur
  const ArchivageFournisseur = async () => {
    try {
      const response = await ArchiveFournisseur(selectedUserId);
      if (response.status === 200) {
        setShowOkModal(true);
        fetchData(); // Refresh data after deletion
      } else {
        throw new Error(
          `Échec lors d'archivage fournisseur: ${response.status}`
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'archivage fournisseur :", error);
    } finally {
      setShowConfirmationModal(false);
    }
  };

  // Cette fonction pour la confirmation Pop Up
  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
  };
  //Cette fonction pour fermer le Pop Up
  const handleOkModalClose = () => {
    setShowOkModal(false);
  };
  // Cette fonction pour la confirmation Pop Up lors de l'archivage fournissseur
  const handleDeleteClick = (userId) => {
    setSelectedUserId(userId);
    setActionType("delete");
    setShowConfirmationModal(true);
  };

  const handleNombreElementParPage = (nbElement) => {
    setNbElement(nbElement); // Update the state with the selected value
  };
  // Update search term and fetch data
  const handleSearch = (term, nbr) => {
    setSearchTerm(term);
    setNbr(1); // Reset to first page
   // fetchData(nbr, nbElement, searchTerm); // Trigger fetch with updated search term
  };
  // useEffect pour charger automatiquement les données lors du montage du composant
  useEffect(() => {
    fetchData(nbr);
  }, [nbr, nbElement, searchTerm, statusFilter, villeFilter, activiteFilter, sortBy]);

  // Colonnes mémorisées pour le composant DynamicTable
  const columns = useMemo(() => {
    return [
      { Header: "ID", accessor: "id" },
      { Header: "Raison Sociale", accessor: "user_profil.RaisonSocial" },
      { Header: "Adresse pick-up", accessor: "user_profil.adresse" },
      { Header: "E-mail", accessor: "email" },
      { Header: "Nombre de commandes", accessor: "orders_count" },
      {
        Header: "Etat",
        accessor: "status",
        Cell: ({ value }) => (
          <Badge className={value === 1 ? "bg-success" : "bg-danger"}>
            {value === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      },
      {
        Header: "Actions",
        Cell: ({ value, row }) => (
          <div>
            <a href={`fournisseur/show/${row.original.id}`} className="p-2">
              <img src={IconShow} width="20px" alt="Voir" />
            </a>
            <a
              href="#"
              className="p-2"
              onClick={() => handleDeleteClick(row.original.id)}
            >
              <img src={IconTrash} width="20px" alt="Supprimer" />
            </a>
          </div>
        ),
      },
    ].filter(Boolean); // Filter out any falsey values
  }, [nbr]); // Add dependencies if needed

  // Render loading message while data is being fetched
  if (!userData) {
    return (
      <Container>
        <p>Chargement...</p>
      </Container>
    );
  }

  // Render the component
  return (
    <Container>
      <div className="userList">
        {/* Breadcrumb navigation */}
        <p className="h6">Accueil / Utilisateurs / Fournisseurs</p>

        {/* Header and filters */}
        <Row className="pt-4 pb-2">
          <Col style={{ display: "flex", alignItems: "center" }}>
            <ClickBack />
            {/* Display dynamic title */}
            <h1 className="p-1">Fournisseurs</h1>
          </Col>
          <Col
            xs
            lg="6"
            className="d-flex justify-content-end align-items-center"
            style={{ alignContent: "right" }}
          >
            {/* add button */}
            <Col
              className="d-flex justify-content-end align-items-center"
              style={{ alignContent: "left" }}
            >
              <a className="btn btn-primary" href="/fournisseur/add">
                Ajouter un Fournisseur
              </a>
            </Col>
          </Col>
        </Row>

        {/* Onglets de filtrage par statut */}
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link
              active={statusFilter === "all"}
              onClick={() => { setStatusFilter("all"); setNbr(1); }}
              style={{ cursor: 'pointer' }}
            >
              Tous
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={statusFilter === "active"}
              onClick={() => { setStatusFilter("active"); setNbr(1); }}
              style={{ cursor: 'pointer' }}
            >
              Actifs
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={statusFilter === "inactive"}
              onClick={() => { setStatusFilter("inactive"); setNbr(1); }}
              style={{ cursor: 'pointer' }}
            >
              Inactifs
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* Filtres avancés */}
        <Row className="pt-2 pb-3 align-items-center">
          <Col md={3}>
            <Form.Group>
              <Form.Label className="mb-1 small">Ville</Form.Label>
              <Form.Control
                type="text"
                placeholder="Filtrer par ville..."
                value={villeFilter}
                onChange={(e) => { setVilleFilter(e.target.value); setNbr(1); }}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="mb-1 small">Activité récente</Form.Label>
              <Form.Select
                value={activiteFilter}
                onChange={(e) => { setActiviteFilter(e.target.value); setNbr(1); }}
              >
                <option value="all">Toutes périodes</option>
                <option value="7days">Derniers 7 jours</option>
                <option value="30days">Derniers 30 jours</option>
                <option value="90days">Derniers 90 jours</option>
                <option value="never">Jamais commandé</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="mb-1 small">Trier par</Form.Label>
              <Form.Select
                value={sortBy}
                onChange={(e) => { setSortBy(e.target.value); setNbr(1); }}
              >
                <option value="date_desc">Date d'inscription (récent)</option>
                <option value="date_asc">Date d'inscription (ancien)</option>
                <option value="alpha_asc">Alphabétique (A-Z)</option>
                <option value="alpha_desc">Alphabétique (Z-A)</option>
                <option value="orders_asc">Nb de commandes (croissant)</option>
                <option value="orders_desc">Nb de commandes (décroissant)</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <ElementsPerPageDropdown
              nbElement={nbElement}
              onNbElementChange={handleNombreElementParPage}
            />
          </Col>
        </Row>
        <SearchBar searchTerm={searchTerm} handleSearch={handleSearch} />
        {/* Render the DynamicTable component */}
        {loading ? (
          // Display loader while data is being fetched
          <p className="lead">Chargement...</p>
        ) : (
          <DynamicTable
          columns={columns}
          data={userData?.data}
          link={userData?.links}
          last_page={userData?.last_page}
          setNbr={setNbr}
          nbr={nbr}
          total={userData?.total}
          name="fournisseurs"
        />
        )}
      </div>
      <ConfirmationModal
        show={showConfirmationModal}
        onClose={handleCloseConfirmationModal}
        onConfirm={ArchivageFournisseur}
        actionType={actionType}
      />
      <OkModal
        show={showOkModal}
        onClose={handleOkModalClose}
        onConfirm={handleOkModalClose}
      />
    </Container>
  );
}

// Export the component as the default export
export default ListFournisseurs;
